import { initializeApp } from "firebase/app";
import { addDoc, collection, getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBy2LygRPucURUWdMOpzrYDxnSIz91LJfM",
  authDomain: "icaconference-438ba.firebaseapp.com",
  projectId: "icaconference-438ba",
  storageBucket: "icaconference-438ba.firebasestorage.app",
  messagingSenderId: "538460972998",
  appId: "1:538460972998:web:666733f9d62ecee9ea74c7",
  measurementId: "G-MG5EW4JDF3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };

